const server = process.env.REACT_APP_BASE_URL || "http://localhost:8085"
export default server